import { ChangeDetectionStrategy, Component, forwardRef, Inject, Input, Optional } from '@angular/core'
import { Product } from '@app-domains/content-blocks/components/product-card/product-card.types'
import { InstantsearchComponent } from '@app-domains/instantsearch/components/instantsearch.component'

@Component({
    selector: 'app-other-products-card',
    templateUrl: './other-products-card.component.html',
    styleUrls: ['./other-products-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class OtherProductsCardComponent {
    @Input()
    public product: Product

    @Input()
    public className: string

    @Input()
    public index: number

    constructor(
        @Optional()
        @Inject(forwardRef(() => InstantsearchComponent))
        public instantSearchInstance: InstantsearchComponent | null,
    ) {
    }

    public handleClick(): void {}
}
